<script setup lang="ts">
import { setup } from './menuSearchContent.setup';

const { component, contentRef } = setup();

defineExpose({
  contentRef,
});
</script>

<template>
  <div
    ref="contentRef"
    class="menu-search-content"
  >
    <component :is="component" />
  </div>
</template>

<style scoped lang="scss">
.menu-search-content {
  height: auto;
  min-height: 220px;
  max-height: 540px;
  padding: 0 12px;
  overflow-y: auto;

  .menu-search-loading-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
</style>
